import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getCurrentUser } from '../api/users';
import StatusMessage from '../components/StatusMessage';
import Button from '../components/common/Button';
import Card from '../components/common/Card';

const AuthCallbackPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser, setToken } = useAuth();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const token = searchParams.get('token');

        if (!token) {
          setError('No authentication token found in URL');
          setIsLoading(false);
          return;
        }

        localStorage.setItem('token', token);
        const userData = await getCurrentUser(token);

        setUser(userData);
        setToken(token);
        localStorage.setItem('user', JSON.stringify(userData));
        navigate('/', { replace: true });
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Authentication failed');
        setIsLoading(false);
      }
    };

    handleCallback();
  }, [searchParams, navigate, setUser, setToken]);

  if (error) {
    return (
      <div className="min-h-screen pt-16 md:pt-20">
        <section className="px-4 py-10 md:py-14">
          <div className="mx-auto max-w-xl">
            <Card className="space-y-6 text-center">
              <div>
                <p className="text-xs uppercase tracking-[0.3em] text-[#8a775f]">Authentication</p>
                <h1 className="mt-3 font-serif text-4xl text-[#231f1c]">Something interrupted sign in.</h1>
              </div>
              <p className="text-sm leading-7 text-red-700">{error}</p>
              <Button type="button" fullWidth onClick={() => navigate('/login')}>
                Return to login
              </Button>
            </Card>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-16 md:pt-20">
      <section className="px-4 py-10 md:py-14">
        <div className="mx-auto max-w-xl text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-[#8a775f]">Authentication</p>
          <h1 className="mt-3 font-serif text-4xl text-[#231f1c]">Completing sign in.</h1>
          {isLoading && <StatusMessage type="loading" className="mx-auto mt-8 max-w-sm" />}
        </div>
      </section>
    </div>
  );
};

export default AuthCallbackPage;
